import { render, staticRenderFns } from "./BandejaLinkPacienteReplicaCEComponente.vue?vue&type=template&id=6040c118&scoped=true"
import script from "./BandejaLinkPacienteReplicaCEComponente.vue?vue&type=script&lang=js"
export * from "./BandejaLinkPacienteReplicaCEComponente.vue?vue&type=script&lang=js"
import style0 from "./BandejaLinkPacienteReplicaCEComponente.vue?vue&type=style&index=0&id=6040c118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6040c118",
  null
  
)

export default component.exports